<template>
  <div>
    <component v-if="view" :is="view" :hotel="hotel" />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
/**
 * Componente que verifica o tipo de tarifa e renderiza a view correta
 */
export default {
  name: 'Base',
  components: {
    AbsoluteRates: () =>
      import(/* webpackPrefetch: true */ './absolute/index.vue'),
    FloatingRates: () =>
      import(/* webpackPrefetch: true */ './floating/index.vue')
  },
  data() {
    return {
      view: null,
      hotel: {}
    }
  },
  created() {
    this.requestHotelConfigs(this.$route.params.id).then((response) => {
      const { tarifarioAbsoluto } = response
      this.hotel = response || {}

      if (tarifarioAbsoluto) {
        this.view = 'AbsoluteRates'
      } else {
        this.view = 'FloatingRates'
      }
    })
  },
  methods: {
    ...mapActions('hotel', ['requestHotelConfigs'])
  }
}
</script>

<style lang="scss" scoped>
::v-deep .lb-breadcrumb--link:nth-child(2) {
  pointer-events: none;
}
</style>
